import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {Agent, Role, Status, Permission} from '../../models';
import { AgentUtility } from "../../util";
import { SalesService } from '../../services/sales.service';

@Component({
  selector: 'app-my-sales',
  templateUrl: './my-sales.component.html',
  styleUrls: ['./my-sales.component.css'],
  providers:[SalesService]
})
export class MySalesComponent implements OnInit {
  showLoadScreen: boolean = false;
  user: Agent = new Agent;

  agent: Agent = new Agent;

  agentType: Agent = new Agent;

  constructor(
    private salesService:SalesService, 
    //private userInfoComponent: UserInfoComponent,
    @Inject(DOCUMENT) private _document: Document,
    private eRef: ElementRef) {
      this.salesService.onStart = () => this.showLoadScreen = true;
      this.salesService.onEnd = () => this.showLoadScreen = false;

  }

  ngOnInit() {
        this.user = new Agent();
        this.agentType = AgentUtility.getLocalUser();
        this.getUserData();
  }


  getUserData(){
    this.agent = AgentUtility.getUser();
    this.salesService.getSales(this.agent.Id).subscribe(data => {
        this.user = data.data;
    });
  }


}
